// The shelf Skills & Technologies renders. Card tech stacks stay specific;
// this file is the decision of what counts. A stack string must be a skill
// here, named in coveredBy, or named in notASkill. skillCatalog.test.js fails
// otherwise. ponytail: the decision is editorial, not a union of every chip.

export const skillCategories = [
  {
    title: "Languages",
    skills: ["Python", "Java", "C++", "C#", "JavaScript", "TypeScript", "Dart", "HTML", "CSS", "Swift", "SQL", "R", "Kotlin", "Bash"]
  },
  {
    title: "Frameworks",
    skills: ["React", "Vue.js", "Node.js", "Express.js", "NestJS", "Flutter", "GetX", "Socket.io", "TypeORM", "TailwindCSS", "Bootstrap", "Framer Motion", "Next.js", "Django", "FastAPI", "Flask", ".NET", "Electron", "Discord.js", "React Query", "Pydantic", "UIKit", "MapKit"]
  },
  {
    title: "Cloud & DevOps",
    skills: ["AWS", "AWS CloudWatch", "AWS SNS", "AWS CDK", "ECS Fargate", "Azure", "Google Cloud Service", "Firebase", "Crashlytics", "Docker", "Kubernetes", "Terraform", "CI/CD", "GitHub Actions", "Git", "Vercel", "Railway", "Fastlane"]
  },
  {
    title: "AI/ML",
    skills: ["Palantir Foundry & AIP", "Pipeline Builder", "Ontology Manager", "Workshop", "Databricks Lakebase", "Genie Code", "Unity Gateway", "Genie Ontology", "Fundamental Nexus", "PySpark", "LangGraph", "MCP", "Agent workflows", "Amazon Bedrock", "RAG", "Vector embeddings", "Gradient boosting", "Time-series forecasting", "Graph algorithms", "PyTorch", "TensorFlow", "Scikit-learn", "Hugging Face Transformers", "CUDA", "JINA CLIP", "OpenCV", "Computer Vision", "AlphaFold", "DynamicBind", "Chai", "Boltz", "Google Gemini", "OpenAI", "Restack.io", "BAML", "E2B Sandboxes", "AWS Rekognition", "Pandas", "NumPy"]
  },
  {
    title: "Databases",
    skills: ["PostgreSQL", "MySQL", "Neo4j", "Redis", "OpenSearch", "Cosmos DB", "DynamoDB", "Firestore", "Firebase"]
  },
  {
    title: "Tools",
    skills: ["AntiGravity", "Windsurf", "Cursor", "OPENCODE", "JetBrains IDEs", "VSCode", "Visual Studio", "Xcode", "iOS SDK", "MapBox SDK", "Google Maps Platform", "Core Location", "Figma", "BullMQ", "OneSignal", "Amplitude", "Meta SDK", "Checkr", "Azure DevOps", "Postman", "PgAdmin", "Chrome Extensions", "Stripe", "Linux", "OAuth 2.0 + JWT", "Server-Sent Events (SSE)"]
  }
];

// A longer card label that is already represented by shelf skills.
export const coveredBy = {
  ".NET Core": [".NET"],
  "AI Agents": ["Agent workflows"],
  "Alpaca MCP": ["MCP"],
  "AsyncIO": ["Python"],
  "AWS (EC2, RDS, S3, Lambda, Cognito)": ["AWS"],
  "AWS (EC2, RDS, S3, OpenSearch, SNS)": ["AWS", "OpenSearch", "AWS SNS"],
  "AWS EC2": ["AWS"],
  "AWS SDK": ["AWS"],
  "Azure Cloud": ["Azure"],
  "Boltz-2": ["Boltz"],
  "Boto3": ["AWS"],
  "BullMQ (Distributed Tasks)": ["BullMQ"],
  "Chai-1": ["Chai"],
  "CI/CD (GitHub Actions)": ["CI/CD", "GitHub Actions"],
  "Cloud Functions": ["Firebase"],
  "Cursor (Liaison & Marketplace Plugin)": ["Cursor"],
  "Cursor Cloud Agents": ["Cursor"],
  "AlphaFold3": ["AlphaFold"],
  "Embedding Systems": ["Vector embeddings"],
  "Fastlane (iOS & Android)": ["Fastlane"],
  "Firebase (Auth, FCM, Crashlytics)": ["Firebase", "Crashlytics"],
  "Firebase Authentication": ["Firebase"],
  "Flutter (Dart)": ["Flutter", "Dart"],
  "GetX (Reactive State)": ["GetX"],
  "Google Cloud Storage": ["Google Cloud Service"],
  "GPU Computing": ["CUDA"],
  "iOS Development": ["iOS SDK"],
  "Jina CLIP": ["JINA CLIP"],
  "LLM Agents": ["Agent workflows"],
  "Logistic Regression": ["Scikit-learn"],
  "Mapbox SDK": ["MapBox SDK"],
  "MCP Architecture": ["MCP"],
  "MCP Servers": ["MCP"],
  "Multimodal Embeddings": ["Vector embeddings"],
  "MySQL / MariaDB (TypeORM)": ["MySQL", "TypeORM"],
  "NestJS (TypeScript)": ["NestJS", "TypeScript"],
  "OpenAI API": ["OpenAI"],
  "PySpark-style pipelines": ["PySpark"],
  "Random Forest": ["Scikit-learn"],
  "Redis (Pub/Sub & Sync)": ["Redis"],
  "S3 + CloudFront": ["AWS"],
  "Stripe API": ["Stripe"],
  "Stripe Connect (Express Payouts)": ["Stripe"],
  "Stripe Identity (KYC Verification)": ["Stripe"],
  "Tailwind CSS": ["TailwindCSS"],
  "Terraform (IaC)": ["Terraform"],
  "Vector search & embeddings": ["Vector embeddings"],
  "Vector Similarity Search": ["Vector embeddings"],
  "WebSocket (Socket.io)": ["Socket.io"]
};

// On a card, and deliberately not a shelf skill: a paper method, a product
// nickname, or a label too broad to sit next to Python.
export const notASkill = [
  "API Caching",
  "App Store Connect (iOS Deployment)",
  "Artificial Intelligence",
  "ASD Database",
  "AWS Cost Optimization",
  "Collaborative Development",
  "Computational Biology",
  "Conformational Dynamics",
  "Cosine Similarity",
  "Custom Routing Algorithms",
  "Deep Learning",
  "Energy Landscape Theory",
  "ESM2 (PLM)",
  "Event-Driven Architecture",
  "Explainable AI",
  "FaceCheckID",
  "Facial Recognition",
  "Firecrawl",
  "Google Play Console (Partner Coord.)",
  "Hardware Integration",
  "HPC",
  "Human Kinases (n=453)",
  "Human-Computer Interaction",
  "Image Preprocessing Pipelines",
  "Linear (Product Management)",
  "Local Frustration Analysis",
  "Machine Learning",
  "Mean Reversion Strategy",
  "Meta Ray Bans",
  "Microservices Architecture",
  "MM-GBSA",
  "Multi-threading",
  "Mutational Scanning",
  "Navigation Systems",
  "NVIDIA DGX A100",
  "Object/link-type modeling",
  "P2Rank",
  "Payment Processing",
  "People Data Labs",
  "Pepper AI chatbot",
  "Protein Language Models (PLMs)",
  "Proteinix",
  "Protenix",
  "Psychology",
  "PyMol Python SDK",
  "Real-time Database",
  "Responsive Design",
  "REST APIs",
  "RESTful APIs",
  "SSOT / unified analytics",
  "Stanford BIOMNI",
  "Structural Biology",
  "Tavily Search API",
  "User Authentication",
  "User Experience Design",
  "Webhooks",
  "Wikipedia API",
  "Workflow Orchestration",
  "yFinance"
];
